import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDirtyState } from 'data/templates';
import { useAllTeamsInAccount } from 'queries/placeholder';
import { useRolesQuery, useRolesWithPlaceholderQuery } from 'queries/roles';
import { fetchProjectTemplate } from '../actions';
import { useActiveProjectTemplate } from './use-active-project-template';
import { useDynamicConditionFields } from './use-project-dynamic-template';
export const useProjectTemplate = (templateId)=>{
    const dispatch = useDispatch();
    const projectTemplateStore = useSelector((state)=>state.templates.project.data[templateId]);
    const template = useActiveProjectTemplate();
    const { isFetched: isRolesFetched } = useRolesWithPlaceholderQuery();
    const { isLoading: isRolesLoading } = useRolesQuery();
    const { isFetched: isTeamsFetched } = useAllTeamsInAccount();
    const dynamicConditionFields = useDynamicConditionFields();
    useEffect(()=>{
        if (!isRolesFetched || isRolesLoading || !isTeamsFetched || isEmpty(dynamicConditionFields)) {
            return;
        }
        dispatch(setDirtyState({
            id: templateId,
            _state: false
        }));
        dispatch(fetchProjectTemplate({
            templateId,
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            dynamicConditionFields
        }));
    }, [
        templateId,
        dispatch,
        isRolesFetched,
        isRolesLoading,
        isTeamsFetched,
        dynamicConditionFields
    ]);
    return {
        ...projectTemplateStore,
        activeTemplate: template
    };
};
